import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import styles from '../../styles';

const splitRowsIntoPages = (items) => {
    const ROW_HEIGHT = 24;
    const PAGE_HEIGHT = 650;  // Total page height
    const FOOTER_HEIGHT = 60; // Space for footer

    let currentHeight = 0;
    const pages = [];
    let currentPage = [];

    items.forEach((item) => {
        if (currentHeight + ROW_HEIGHT > PAGE_HEIGHT - FOOTER_HEIGHT) {
            pages.push(currentPage);
            currentPage = [];
            currentHeight = 0;
        }
        currentPage.push(item);
        currentHeight += ROW_HEIGHT;
    });

    if (currentPage.length > 0) pages.push(currentPage);

    return pages;
};


const TableHeader = () => (
    <View style={[styles.tableRow, { marginTop: 0 }]} fixed>
        <Text style={[styles.tableCell, { flex: 0.3 }, styles.ItemHeaderCell, styles.serialNumberCell]}>Sr No.</Text>
        <Text style={[styles.tableCell, styles.ItemHeaderCell, styles.descriptionHeaderCell, styles.descriptionCell]}>Description</Text>
        <Text style={[styles.tableCell, { flex: 1 }, styles.ItemHeaderCell]}>HSN</Text>
        <Text style={[styles.tableCell, { flex: 0.75 }, styles.ItemHeaderCell]}>Qty</Text>
        <Text style={[styles.tableCell, { flex: 0.75 }, styles.ItemHeaderCell]}>Unit</Text>
        <Text style={[styles.tableCell, { flex: 1 }, styles.ItemHeaderCell]}>Rate</Text>
        <Text style={[styles.tableCell, { flex: 0.75 }, styles.ItemHeaderCell]}>Disc{'\n'}(%)</Text>
        <Text style={[styles.tableCell, { flex: 0.75 }, styles.ItemHeaderCell]}>CGST{'\n'}(%)</Text>
        <Text style={[styles.tableCell, { flex: 0.75 }, styles.ItemHeaderCell]}>SGST{'\n'}(%)</Text>
        <Text style={[styles.tableCell, { flex: 0.75 }, styles.ItemHeaderCell]}>IGST{'\n'}(%)</Text>
        <Text style={[styles.tableCellLast, { flex: 1.2 }, styles.ItemHeaderCellLast]}>Amount</Text>
    </View>
);

const TableDetails = ({ items = [] }) => {
    const pages = splitRowsIntoPages(items);

    return (
        <>
            {pages.map((pageItems, pageIndex) => (
                <React.Fragment key={pageIndex}>
                    {pageItems.map((item, index) => {
                        // determine if this is the last row on the current page
                        const isLastRowOnPage = index === pageItems.length - 1;

                        // bottom‐border style for last row
                        const bottomBorderStyle = isLastRowOnPage
                            ? { borderBottomWidth: 1, borderBottomColor: '#000' }
                            : {};
                        return (
                            <View key={index} style={styles.tableRow}>
                                <Text style={[styles.tableCell, styles.serialNumberCell, { flex: 0.3 }, isLastRowOnPage && { borderBottomWidth: 1, borderBottomColor: '#000' }]}>{index + 1 + pageIndex * pageItems.length}</Text>
                                <Text style={[styles.tableCell, styles.descriptionCell, isLastRowOnPage && { borderBottomWidth: 1, borderBottomColor: '#000' }]}>{item.description}</Text>
                                <Text style={[styles.tableCell, styles.centerAlign, { flex: 1 }, isLastRowOnPage && { borderBottomWidth: 1, borderBottomColor: '#000' }]}>{item.hsnCode}</Text>
                                <Text style={[styles.tableCell, styles.rightAlign, { flex: 0.75 }, isLastRowOnPage && { borderBottomWidth: 1, borderBottomColor: '#000' }]}>{item.qty} </Text>
                                <Text style={[styles.tableCell, styles.centerAlign, { flex: 0.75 }, isLastRowOnPage && { borderBottomWidth: 1, borderBottomColor: '#000' }]}>PCS</Text>
                                <Text style={[styles.tableCell, styles.rightAlign, { flex: 1 }, isLastRowOnPage && { borderBottomWidth: 1, borderBottomColor: '#000' }]}>{item.rate} </Text>
                                <Text style={[styles.tableCell, styles.rightAlign, { flex: 0.75 }, isLastRowOnPage && { borderBottomWidth: 1, borderBottomColor: '#000' }]}>{item.discount} </Text>
                                <Text style={[styles.tableCell, styles.rightAlign, { flex: 0.75 }, isLastRowOnPage && { borderBottomWidth: 1, borderBottomColor: '#000' }]}>{item.cgst} </Text>
                                <Text style={[styles.tableCell, styles.rightAlign, { flex: 0.75 }, isLastRowOnPage && { borderBottomWidth: 1, borderBottomColor: '#000' }]}>{item.sgst} </Text>
                                <Text style={[styles.tableCell, styles.rightAlign, { flex: 0.75 }, isLastRowOnPage && { borderBottomWidth: 1, borderBottomColor: '#000' }]}>{item.igst} </Text>
                                <Text style={[styles.tableCellLast, styles.rightAlign, { flex: 1.2 }, isLastRowOnPage && { borderBottomWidth: 1, borderBottomColor: '#000' }]}>{item.amount} </Text>
                            </View>
                        )
                    })}
                </React.Fragment>
            ))}
        </>
    );
};



export { TableHeader, TableDetails };